import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const GlobalScrollManager = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // GLOBAL CONTROL HERE
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth", // change to "auto" if needed
    });
  }, [pathname]);

  return null;
};

export default GlobalScrollManager;
